import { extend } from 'vee-validate';
import i18next from 'i18next';
import { formatCurrency } from '@/core/currency/helpers';

extend('more_than', {
    validate(value, { actualValue, min }:any) {
        try {
            return (actualValue >= min);
        } catch (e) {
            return false;
        }
    },
    params: ['actualValue', 'min', 'currency'],
    message: (_, { min, currency }) => i18next.t('errors:more_than', { currencySymbol: currency.symbol, amount: formatCurrency(min, currency.format, '0,0.00') })
});
